import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetUserAttributionV1Response } from './get-user-attribution-v1-response';
import { getUserAttributionV1ResponseSchema } from './get-user-attribution-v1-response';

export async function getUserAttributionV1Api(
  userId: string,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetUserAttributionV1Response>> {
  return getRequest<IGetUserAttributionV1Response>({
    path: `/sys/attribution/v1/users/${userId}`,
    schema: getUserAttributionV1ResponseSchema,
    options,
  });
}
